import React from 'react';
import {NoticesUIProvider} from "./NoticesUIContext";
import {NoticesCard} from "./NoticesCard";
import {Route} from "react-router-dom";
import {NoticeDeleteDialog} from "./notice-delete-dialog/NoticeDeleteDialog";


export function NoticesPage({history}) {

    const noticesUIEvents = {
        newNoticeButtonClick: () => {
            history.push('/operation/notices/new');
        },
        viewNoticeButtonClick: (id) => {
            history.push(`/operation/notices/${id}/view`);
        },
        deleteNoticeButtonClick: (id) => {
            history.push(`/operation/notices/${id}/delete`);
        }
    }


    return (
        <NoticesUIProvider noticesUIEvents={noticesUIEvents}>

            <Route path={"/operation/notices/:id/delete"}>
                {({history, match}) => (
                    <NoticeDeleteDialog
                        show={match != null}
                        id={match && match.params.id}
                        onHide={() => history.push("/operation/notices")}
                    />
                )}
            </Route>

            <NoticesCard/>
        </NoticesUIProvider>
    )


}